module.exports = __webpack_public_path__ + "64bcaaa324b54548cad5a8fccb839012.svg";